import { parse as jsonParse, stringify as jsonStringify } from 'superjson'
import lodashSet from 'lodash/set'

export default {
  methods: {
    handleErrorResponse(e) {
      if (e?.response?.status !== 422) return

      this.errors = this.fromDotToNested(e.response.data.errors)
    },

    fromDotToNested(obj) {
      const result = {}

      // For each object path (property key) in the object
      for (const objectPath in obj) {
        lodashSet(result, objectPath, obj[objectPath])
      }

      return jsonParse<any>(jsonStringify(result))
    },

    hasError(obj, prop, ...restProps) {
      if (obj === undefined) return false

      if (
        restProps.length === 0 &&
        Object.prototype.hasOwnProperty.call(obj, prop)
      ) {
        return true
      }

      return this.hasError(obj[prop], ...restProps)
    },
  },
}
